import { css } from '@emotion/react';
import { Header } from '@frontend/header-navigation';
import { useTranslation } from '@frontend/i18n';
import { breakpoints, useMatchMedia } from '@frontend/responsiveness';
import { useNavigate } from '@frontend/weave-router';
import { theme } from '@frontend/theme';
import { Button } from '@frontend/design-system';
import { PaymentPlanQuickFilters } from '../../components/PaymentPlans/PaymentPlanFilter/quick-filters';
import { PaymentPlanList } from '../../components/PaymentPlans/PaymentPlanList/payment-plan-list';
import { PaymentPlanMobileList } from '../../components/PaymentPlans/PaymentPlanList/payment-plan-mobile-list';
import { PaymentPlanSummaryCard } from '../../components/PaymentPlans/PaymentPlanSummary';
import { PaymentsPage } from '../../components/PaymentsPage';
import { usePaymentPlanSearch } from '../../hooks/use-payment-plan-search';

export const PaymentPlans = () => {
  const { t } = useTranslation('payments');
  const navigate = useNavigate();
  const isMobile = useMatchMedia({ maxWidth: breakpoints.small.min });

  const { summary, loading } = usePaymentPlanSearch();

  return (
    <PaymentsPage
      title={<Header title={t('Payment Plans')} />}
      action={
        <Button
          trackingId='pay-portal-paymentplans-btn-newplan'
          variant='primary'
          size='large'
          iconName='plus'
          onClick={() => navigate({ to: '/payments/payment-plans/create' })}
        >
          {isMobile ? t('New') : t('New Payment Plan')}
        </Button>
      }
      css={
        isMobile
          ? css`
              @media (max-width: ${breakpoints.small.min}px) {
                padding: 0px;
              }
              .page-header {
                padding: ${theme.spacing(3)};
              }
            `
          : undefined
      }
    >
      <div
        css={css`
          padding: ${theme.spacing(0, 3)};
          margin-bottom: ${theme.spacing(3)};
        `}
      >
        <PaymentPlanQuickFilters />
      </div>
      <PaymentPlanSummaryCard summary={summary} loading={loading} />
      {isMobile ? <PaymentPlanMobileList /> : <PaymentPlanList />}
    </PaymentsPage>
  );
};
